import type { Connection } from '../types/Connection';

/**
 * Лимит maxLiveConnections расходуют пульт (room) и экраны спикера (viewer);
 * прочие клиенты по умолчанию в лимите. Не расходуют слот: legacy moderator
 * (как второй room) и agenda.
 */
export function doesConnectionUseLiveSlot(c: Pick<Connection, 'type'>): boolean {
  return c.type !== 'moderator' && c.type !== 'agenda';
}
